import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { CartListModel } from 'src/app/models/cart-list.model';
import { CartService } from 'src/app/services/cart/cart.service';
import { BillingAddressService } from 'src/app/services/billing-address/billing-address.service';
import { BillingListModel } from 'src/app/models/billing-address.model';
@Injectable({
  providedIn: 'root'
})
export class BillingAddressResolverService implements Resolve<any> {

  constructor(private billingService: BillingAddressService,
    private sessionService: BrowserStorageService) { }

    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<Array<BillingListModel>>|Promise<Array<BillingListModel>>| Array<BillingListModel> {
      return this.getCartList()
    }

  /**
   * Get Licence Data
   * @returns
   */
  getCartList(): Observable<Array<BillingListModel>> {
    let billingAddress: Array<BillingListModel> = [];
      if (!this.sessionService.getSessionData()) {
          billingAddress = [];
          return of(billingAddress)
      } else {
        return this.billingService.getBillingAddress().pipe(
          map((response: Array<BillingListModel>) => {
            billingAddress = response;
            return billingAddress;
        }),catchError((error) => {
          return of(billingAddress);
        }));
      }
  }
}
